import { render } from "./prompts-table.vue?vue&type=template&id=048a871d&scoped=true&lang=pug"
import script from "./prompts-table.vue?vue&type=script&lang=js"
export * from "./prompts-table.vue?vue&type=script&lang=js"

import "./prompts-table.vue?vue&type=style&index=0&id=048a871d&scoped=true&lang=scss"
import "./prompts-table.vue?vue&type=style&index=1&id=048a871d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048a871d"]])

export default __exports__